import moment from 'moment';

const options: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  // hour12: false,
  hourCycle: 'h23',
};
const formatter = new Intl.DateTimeFormat('en-US', options);

/**
 * Format date with pattern: MM/DD/YYYY hh:mm
 * @param date
 * @returns
 */
const formatDateTime = (date: Date | string) => {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return formatter.format(date).replace(',', '');
};

const formatDateTimeOrEmpty = (value: Date | string | null | undefined): string => {
  if (!value) {
    return '';
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return `${date.toLocaleDateString('en-US')} ${date.toLocaleTimeString('en-US')}`;
};

/**
 * Format date with given pattern, default: DD/MM/YYYY
 * @param date
 * @returns
 */
const formatDate = (date: Date | string, pattern: string = 'DD/MM/YYYY') => {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return moment(date).format(pattern);
};

const DateHelper = {
  formatDateTime,
  formatDate,
  formatDateTimeOrEmpty,
};
export default DateHelper;
